import { useConsentStore } from "../store/consentStore";
import { closeSentry, initSentry } from "./sentry";

/**
 * Applies this device's stored answers: Sentry runs only after crash_reports was ACCEPTED, and stops otherwise.
 * No answer yet → nothing starts (the storage banner asks first). An answer to an older version is dropped by the
 * banner when the server says the topic needs an answer again, so Sentry stops until the new answer.
 * external_media is stored here too; the external players, thumbnails and third-party streams read it through
 * `lib/externalMedia.ts` (useExternalMediaAllowed / shownImage / isFirstPartyUrl).
 */
export function applyDeviceConsent(): void {
  const crash = useConsentStore.getState().device.crash_reports?.decision;
  if (crash === "ACCEPTED") initSentry();
  else closeSentry();
}
